import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CommonPage from "../../components/common-page";
import { Alert, Skeleton } from "@mui/material";
import useLanguage from "../../hooks/useLanguage";
import styled from "styled-components";
import IButton from "../../components/iconButton";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

const StyledSkeleton = styled(Skeleton)`
  background-color: ${({ theme }) =>
    theme.palette.background.default}21 !important;
`;
export default function EditorSkeleton() {
  const [
    {
      pages: { editor: text },
    },
  ] = useLanguage();
  return (
    <CommonPage
      title={text.title}
      subtitle={text.subtitle}
      actions={[
        <IButton
          key="metadata"
          onClick={() => {}}
          variant="outlined"
          color="action"
          startIcon={<OpenInNewRoundedIcon />}
        >
          <Skeleton variant="text" width={64} />
        </IButton>,
        <IButton
          key="download"
          onClick={() => {}}
          variant="outlined"
          color="action"
          startIcon={<DownloadRoundedIcon />}
        >
          <Skeleton variant="text" width={70} />
        </IButton>,
        <IButton
          key="save"
          onClick={() => {}}
          variant="contained"
          color="action"
          startIcon={<SaveRoundedIcon />}
        >
          <StyledSkeleton variant="text" width={33} />
        </IButton>,
      ]}
    >
      <Alert severity="info">
        <Skeleton variant="text" width={500} />
      </Alert>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          gap: "10px",
          height: 50,
        }}
      >
        <Skeleton variant="text" width={30} />
        <Skeleton variant="text" width={100} />
        <Skeleton variant="text" width={20} />
        <Skeleton variant="text" width={40} />
        <Skeleton variant="text" width={40} />
        <Skeleton variant="text" width={40} />
        <Skeleton variant="text" width={40} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Skeleton variant="text" width={"65%"} height={20} />
        <Skeleton variant="text" width={"25%"} height={20} />
        <Skeleton variant="text" width={"85%"} height={20} />
        <Skeleton variant="text" width={"15%"} height={20} />
        <Skeleton variant="text" width={"75%"} height={20} />
        <Skeleton variant="text" width={"35%"} height={20} />
        <Skeleton variant="text" width={"95%"} height={20} />
        <Skeleton variant="text" width={"12%"} height={20} />
        <Skeleton variant="text" width={0} height={20} />
        <Skeleton variant="text" width={"68%"} height={20} />
        <Skeleton variant="text" width={"28%"} height={20} />
        <Skeleton variant="text" width={"88%"} height={20} />
        <Skeleton variant="text" width={"18%"} height={20} />
        <Skeleton variant="text" width={"72%"} height={20} />
        <Skeleton variant="text" width={"32%"} height={20} />
        <Skeleton variant="text" width={"92%"} height={20} />
        <Skeleton variant="text" width={"22%"} height={20} />
        <Skeleton variant="text" width={0} height={20} />
        <Skeleton variant="text" width={"78%"} height={20} />
        <Skeleton variant="text" width={"38%"} height={20} />
        <Skeleton variant="text" width={"82%"} height={20} />
        <Skeleton variant="text" width={"16%"} height={20} />
        <Skeleton variant="text" width={"83%"} height={20} />
        <Skeleton variant="text" width={"47%"} height={20} />
        <Skeleton variant="text" width={"91%"} height={20} />
        <Skeleton variant="text" width={"23%"} height={20} />
        <Skeleton variant="text" width={"64%"} height={20} />
        <Skeleton variant="text" width={"42%"} height={20} />
        <Skeleton variant="text" width={"89%"} height={20} />
        <Skeleton variant="text" width={"31%"} height={20} />
        <Skeleton variant="text" width={"76%"} height={20} />
        <Skeleton variant="text" width={"44%"} height={20} />
        <Skeleton variant="text" width={"93%"} height={20} />
        <Skeleton variant="text" width={0} height={20} />
        <Skeleton variant="text" width={"27%"} height={20} />
        <Skeleton variant="text" width={"61%"} height={20} />
        <Skeleton variant="text" width={"39%"} height={20} />
        <Skeleton variant="text" width={"87%"} height={20} />
        <Skeleton variant="text" width={"33%"} height={20} />
      </div>
    </CommonPage>
  );
}
